<style lang="scss" scope>
.ivu-mt,
.ivu-mt-16 {
  margin-top: 16px !important;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.flex {
  display: flex !important;
  width: 100%;
}

.l-table-place {
  height: auto;
  min-height: 250px;
}

.flex-warp {
  flex-wrap: wrap;
}

.ivu-mr,
.ivu-mr-16 {
  margin-right: 16px !important;
}

.ivu-mt,
.ivu-mt-16 {
  margin-top: 16px !important;
}

.mr1 {
  margin-right: 1rem;
  word-wrap: +break-word;
  word-break: +norm;
}

.flexs {
  display: flex !important;
  width: 20%;
}

//  需要改某一个 样式    equipment 下面的 子 el-form-item__label
.equipment .el-form-item__label {
  line-height: 22px;
}
</style>

<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-place">

      <div class="flex items-center justify-between ivu-mt">
        <div class="flex items-center">
          <p>场所类型：</p>
          <el-row>
            <el-button type="info" :class="{ active: search_data.type == item.id ? true : false }" plain
              v-for="item in place_type_list" :key="item.id" @click="placetype(item.id)"
              v-model="search_data.type">{{ item.name }}</el-button>
          </el-row>
        </div>
      </div>

      <div class="flex flex-warp">

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">场所名称</p>
          <el-input placeholder="请输入场所名称" v-model="search_data.name" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属街道</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.street_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in street_list" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属社区</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.community_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in community_list" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">网格名称</p>
          <el-input placeholder="请输入网格名称" v-model="search_data.network" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">排序方式</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.sort_state" placeholder="全部" clearable @change="changes">
              <el-option v-for="(item, index) in SORT_TYPE" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">场所状态</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.state" placeholder="全部" clearable @change="changes">
              <el-option v-for="(item, index) in PLACE_STATUS" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">排序</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.sort" placeholder="全部" clearable @change="changes">
              <el-option v-for="(item, index) in SORT" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">日期</p>
          <div class="l-show-more-search" style="width: 76%;">
            <el-date-picker v-model="value2" type="daterange" autocomplete="off" @blur="onPick(false)" clearable
              value-format="yyyy-MM-dd" start-placeholder="请选择有效起始时间" end-placeholder="请选择有效结束时间" @change="onPick(false)">
            </el-date-picker>
          </div>
        </div>
        <div class="flex items-center justify-between ivu-mt">
          <div class="flex items-center">
          <p>数据导出：</p>
          <el-row>
            <l-auth-button class="ivu-mr" type="info" auth="EquipmentInstall_equipmentExport1"
                @click="placeAccount('placeEquipmentInstall_equipmentExport1')" :loading="export_loading"> 导出明细(需要勾选)
              </l-auth-button>
              <l-auth-button class="ivu-mr" type="info" auth="EquipmentInstall_equipmentExport2"
                @click="placeAccount('placeEquipmentInstall_equipmentExport2')" :loading="export_loading"> 导出申报场所
              </l-auth-button>
              <l-auth-button class="ivu-mr" type="info" auth="EquipmentInstall_equipmentExport3"
                @click="placeAccount('placeEquipmentInstall_equipmentExport3')" :loading="export_loading"> 导出申报材料
              </l-auth-button>
              <l-auth-button class="ivu-mr" type="info" auth="EquipmentInstall_equipmentExport4"
                @click="placeAccount('placeEquipmentInstall_equipmentExport4')" :loading="export_loading"> 导出申报档案
              </l-auth-button>
              <l-auth-button class="ivu-mr" type="info" auth="EquipmentInstall_equipmentExport1_All"
                @click="placeAccount('placeEquipmentInstall_equipmentExport1','all')" :loading="export_loading"> 导出全部场所明细
              </l-auth-button>
            </el-row>
          </div>
        </div>
      </div>
    </div>

    <div class="l-primary l-table-config" style=" border-bottom: solid 1px #e4e7ed;">
      <el-popover placement="bottom-start" width="200" trigger="click" popper-class="l-table-column-fixed-select-box">
        <span slot="reference">
          <i class="el-icon-setting"></i>表格列表配置
        </span>
        <div class="">
          <div class="l-flex l-flex-just-between" style="margin-bottom:10px">
            <div>
              表格列表配置
              <i class="el-icon-refresh-left" style="float:right;  color: red;margin: 3px;"
                @click="resetFixedCheck">重置</i>
            </div>
          </div>
          <el-divider class="l-table-column-fixed-title-divider"></el-divider>
          <el-checkbox-group v-model="fixed_list">
            <div v-for="(item, index) in columns" :key="index">
              <el-checkbox :label="item.prop" style="margin-bottom:4px">
                {{ item.label }}
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </el-popover>

    </div>
    <l-table ref="multipleTable" :data="data" v-loading="loading" row-key="id" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55">
      </el-table-column>

      <el-table-column v-for="(item, index) in columns" :key="index" v-bind="{ ...item }" :label="item.label"
        show-overflow-tooltip>
        <template v-slot="{ row }">
          <!-- <template v-if="item.prop == 'state'">
              <el-tag type="success" disable-transitions>{{ MANAGEMENT[row.state] }}</el-tag>
            </template>
            -->
          <template v-if="item.prop == 'name'">
            <a style="color: #0C87FF;" @click="placeInfo(row.place_id)"> {{ row.name }}</a>

          </template>
          <template v-else>
            {{ row[item.prop] }}
          </template>
        </template>
      </el-table-column>


    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
      :current-page.sync="page"></l-page>


    <!--详情-->
    <l-dialog :visible.sync="place_info_visible" title="场所信息" width="1600px">
      <l-place-info :visible.sync="place_info_visible" :id="place_id" is-info />
    </l-dialog>

  </el-card>
</template>
<script>
import { PLACE_STATUS, SORT, SORT_TYPE } from "@/common/constants/install";
import PlaceInfo from "../place/Info.vue";
import Vue from "vue";
export default {
  name: "equipment-mange",
  components: {
    [PlaceInfo.name]: PlaceInfo,
  },
  data() {
    return {
      PLACE_STATUS: PLACE_STATUS,
      SORT: SORT,
      SORT_TYPE: SORT_TYPE,
      value1: '',
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
      change_state_loading: [],
      export_loading: false,
      add_visible: false, //是否显示添加
      info_visible: false, //是否显示编辑
      edit_visible: false, //是否显示编辑
      place_info_visible: false,
      edit_id: 0,
      info_id: 0,
      place_id: 0,
      place_type_list: [],
      community_list: [],
      street_list: [],
      industry_list: [
        { "id": 1, "name": "行业" }
      ],

      //搜索
      search_visible: false,
      search_data: {
        name: "",
        network: "",
        community_id: '',
        street_id: '',
        state: '0',
        start_time: '',
        end_time: '',
        sort_state: '1',
        sort: '1',
        type: 2,
      },
      rel_search_data: {},
      show_more_search: false,
      value2: '',
      multipleSelection: [],
      //默认
      re_fixed_list: ["index", "community_name", "place_sn", "name", "doorplate_address"],
      fixed_list: ["index", "community_name", "place_sn", "name", "doorplate_address"],
    };
  },
  computed: {
    columns() {
      let columns = [
        {
          prop: "index",
          label: "序号",
          fixed: true,
          width: "60",
        },
        {
          prop: "place_id",
          label: "场所ID",
          fixed: true,
          width: "70",
        },
        {
          prop: "community_name",
          label: "所属社区",
          fixed: true,
          Width: "80",
        },

        {
          prop: "place_sn",
          label: "场所编码",
          fixed: true,
          Width: "140",
        },
        {
          prop: "name",
          label: "场所名称",
          fixed: true,
          Width: "140",
        },
        {
          prop: "address",
          label: "场所地址",
          fixed: true,
          width: "140",
        },

        // {
        //   prop: "null",
        //   label: "场所负责人",
        //   fixed: true,
        //   width: "80",
        // },
        // {
        //   prop: "null",
        //   label: "负责人电话",
        //   fixed: true,
        //   width: "120",
        // },
        {
          prop: "created_at",
          label: "申报时间",
          fixed: true,
          width: "160",
        },
        {
          prop: "null",
          label: "安装时间",
          fixed: true,
          width: "160",
        },
        {
          prop: "null",
          label: "场所状态",
          fixed: true,
          width: "120",
        },
      ];

      let result = columns.map((item) => {
        const index = this.fixed_list.findIndex((itm) => {
          return itm == item.prop;
        });
        if (index != -1) {
          item.fixed = true;
          if (!item.width) {
            item.width = item.minWidth;
          }
        } else {
          if (item.minWidth && item.width) {
            delete item.width;
          }
          item.fixed = false;
        }

        return item;
      });

      return result;
    },
  },

  watch: {

    fixed_list(val) {
      if (val.length > 20) {
        this.fixed_list.shift();
      }
    },
  },

  mounted() {
    this.getList();
    this.getSearchData();
  },

  methods: {


    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //通过类型筛选
    placetype(id) {
      this.search_data.type = id;
      this.rel_search_data = this.search_data;
      this.getList();
    },
    changes() {
      this.rel_search_data = this.search_data;
      this.getList();
    },
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("placeEquipmentInstall_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //
    placeInfo(id) {
      this.place_id = id;
      this.$nextTick(() => {
        this.place_info_visible = true;
      });
    },
    //获取搜索信息 
    getSearchData() {
      this.loading = true;
      this.$_invoke("place_getSearchData", {
      })
        .then((ret) => {
          this.street_list = ret.street_list;
          this.community_list = ret.community_list;
          this.place_type_list = ret.place_type_list;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },
    //显示详情
    showInfo(id) {
      this.info_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },
    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSucess() {
      this.edit_visible = false;
      this.getList();
    },
    //时间搜索
    onPick(cant) {
      if (!this.value2) {
        this.value2 = "";
        this.search_data.start_time = "";
        this.search_data.end_time = "";
      } else {
        this.search_data.start_time = this.value2[0];
        this.search_data.end_time = this.value2[1];
      }
      if (!cant) {
        this.onSearch();
      }
    },
    //重置固定栏位选择
    resetFixedCheck() {
      this.fixed_list = JSON.parse(JSON.stringify(this.re_fixed_list));
    },
    //导出
    placeAccount(url,mode) {
      if(mode != 'all' && this.multipleSelection.length==0){
        this.$message.error('请先选择要导出的场所');
        return;
      }
      const select_place_id=this.multipleSelection.map((v)=>v["id"]);
      this.export_loading = true;

      if(mode != 'all'){
        this.$_invoke(url, { type: this.search_data.type, ...this.rel_search_data, place_id: select_place_id })
        .then((ret) => {
          window.open(ret);
        })
        .finally(() => {
          this.export_loading = false;
        });

      } else {
        this.$_invoke(url, { type: this.search_data.type, ...this.rel_search_data})
        .then((ret) => {
          window.open(ret);
        })
        .finally(() => {
          this.export_loading = false;
        });
      }
      
    },
  },
};
</script>
